import {
	Injectable,
	Output,
	EventEmitter
} from '@angular/core';
import {
	AvlaRestClientService,
	UserInfoDTO,
	AuthService
} from 'base-angular-avla';
import {
	DatePipe
} from '@angular/common';
import {
	Observable, of
} from 'rxjs';
import {map} from 'rxjs/operators';
import { AvlaGenericComponent, I18nService, MessageService } from 'shared-angular-components-avla';
import { Router } from '@angular/router';
import {CountryDTO} from './DTOs/CountryDTO';

@Injectable()
export class CountriesService extends AvlaGenericComponent {
	constructor(
		protected messageService: MessageService,
		protected i18n: I18nService,
		protected router: Router,
		protected authService: AuthService,
		protected restClientService: AvlaRestClientService,
		protected datePipe: DatePipe
	) {
		super(restClientService, messageService, router, authService, i18n);
		CountriesService.instance = CountriesService.instance || this;
		return CountriesService.instance;
	}
	static instance: CountriesService;

	private countries: CountryDTO[];

	@Output() countryCodeGlobalChanged: EventEmitter<any> = new EventEmitter();

	private _countryCodeGlobal;
	private _proposalViewer;

	public set countryCodeGlobal(cd) {
		if (cd !== this._countryCodeGlobal) {
			this._countryCodeGlobal = cd;
			this.countryCodeGlobalChanged.emit(true);
			// console.log("countryCodeGlobal",cd);
			if (cd) {
				/*
			setTimeout(() => {
				this.findCurrencyCodeForLimitedCumulus(cd).subscribe((data) => {
					if (this.errorInResponse(data)) {
						console.error("Error en findCurrencyCodeForLimitedCumulus, reintente más tarde");
						return;
					}
				},
				(error) => {
					console.error("Error en findCurrencyCodeForLimitedCumulus, reintente más tarde");
				});
				(error) => {
					console.error("Error en proposalViewer, reintente más tarde", error);
				});
			}, 500);
			*/
			}
		}
	}

	public get countryCodeGlobal() {
		return this._countryCodeGlobal;
	}

	public findCountriesUrl: string = '/api-segurocredito/findCountries';

	public isLoadingFindCountries = false;

	public validateCountryCodeByGroup(countryCode: string, userInfoDto: UserInfoDTO): boolean {
		if (!userInfoDto || !userInfoDto.groups || userInfoDto.groups.length === 0) {
			return false;
		}
		if (userInfoDto.username === 'admin' && userInfoDto.id === 1) {
			return true;
		}
		for (const g of userInfoDto.groups) {
			if ( 'SC - CHILE' === g.name  && 'CL' === countryCode ) {
				return true;
			} else if ( 'SC - PERU' === g.name  && 'PE' === countryCode ) {
				return true;
			} else if ( 'SC - MEXICO' === g.name  && 'MX' === countryCode ) {
				return true;
			} else if ( 'SC - BR' === g.name  && 'BR' === countryCode ) {
				return true;
			} else if ( 'SC - US' === g.name  && 'US' === countryCode ) {
				return true;
			}
		}
		return false;
	}

	public setDefaultContryCodeGlobal(userInfoDto: UserInfoDTO) {
		if (!this.countryCodeGlobal) {
			for (let g of userInfoDto.groups) {
				if ( 'SC - CHILE' === g.name ) {
					this.countryCodeGlobal = 'CL';
					return true;
				} else if ( 'SC - PERU' === g.name ) {
					this.countryCodeGlobal = 'PE';
					return true;
				} else if ( 'SC - MEXICO' === g.name ) {
					this.countryCodeGlobal = 'MX';
					return true;
				} else if ( 'SC - BR' === g.name ) {
					this.countryCodeGlobal = 'BR';
					return true;
				}  else if ( 'SC - US' === g.name ) {
					this.countryCodeGlobal = 'US';
					return true;
				}
			}
			//TODO: fix temporal en caso de que no exista 
			this.countryCodeGlobal = 'CL';
		}
	}

	public getCountryDTO(cd: string): CountryDTO {
		if (!cd || !this.countries) {
			return undefined;
		}
		for (const country of this.countries) {
			if (country.isoCode === cd) {
				return country;
			}
		}
	}

	public findCountries(): Observable<CountryDTO[]> {
		if (this.isLoadingFindCountries) {
			setTimeout(() => {
				return this.findCountries();
			}, 2000);
		}
		this.isLoadingFindCountries = true;
		if (this.countries) {
			return of(this.countries);
		}
		return this.restClientService.getList(this.findCountriesUrl, null, null).pipe(map(
			(data) => {
				this.countries = data;
				this.countries = this.countries.sort((a, b) => a.name < b.name ? -1 : a.name > b.name ? 1 : 0);
				this.isLoadingFindCountries = false;
				return this.countries;
			}
		));
	}


	normalizeCountryIsoCode(cdCountry: string): string {
    return cdCountry.replace("-", "").toUpperCase();
  }
}
